import { format } from 'date-fns'
import { getAccess } from '../../helpers/ReduxHelpers'

export const PTL_BILLING_ACCESS = 'PTL_BILLING'

/** True when the login holds PTL_BILLING (settings, terms, diesel price, approve, files). The server checks again. */
export const canBill = () => {
  try {
    return (getAccess() || []).includes(PTL_BILLING_ACCESS)
  } catch (e) {
    return false
  }
}

/** ₹ with Indian grouping; null → '—'. */
export const inr = (v, digits = 2) => {
  if (v === null || v === undefined || v === '') return '—'
  const n = Number(v)
  if (Number.isNaN(n)) return '—'
  return (n < 0 ? '−₹' : '₹') + Math.abs(n).toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export const pct = (v) => (v === null || v === undefined ? '—' : `${(Number(v) * 100).toFixed(1)}%`)

export const fmtDate = (d) => (d ? format(new Date(d), 'dd MMM yyyy') : '—')
export const fmtDateTime = (d) => (d ? format(new Date(d), 'dd MMM yyyy, HH:mm') : '—')

/** YYYY-MM of today in IST (the backend's cycle months are IST). */
export const currentMonth = () => {
  const ist = new Date(Date.now() + (330 + new Date().getTimezoneOffset()) * 60000)
  return `${ist.getFullYear()}-${String(ist.getMonth() + 1).padStart(2, '0')}`
}

/** The last n months, newest first: [{ value: '2026-10', label: 'October 2026' }]. */
export const recentMonths = (n = 6) => {
  const [y, m] = currentMonth().split('-').map(Number)
  const out = []
  for (let i = 0; i < n; i++) {
    const d = new Date(y, m - 1 - i, 1)
    out.push({ value: `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`, label: format(d, 'MMMM yyyy') })
  }
  return out
}

export const monthLabel = (ym) => {
  if (!ym) return ''
  const [y, m] = ym.split('-').map(Number)
  return format(new Date(y, m - 1, 1), 'MMMM yyyy')
}

/** The day `day` of the month after `ym`, as '05 Nov 2026'. */
export const dayOfNextMonth = (ym, day) => {
  const [y, m] = ym.split('-').map(Number)
  return format(new Date(y, m, day), 'dd MMM yyyy')
}

export const errText = (e, fallback = 'Something went wrong.') => e?.data?.message || e?.message || fallback

export const ADHOC_STATE = {
  COMPLETE: { label: 'Complete', color: 'success' },
  WAITING_OPS: { label: 'Waiting for Ops', color: 'warning' },
  WAITING_KAM: { label: 'Waiting for KAM', color: 'warning' },
}

/** A month param from the URL, kept to the last 12 months. */
export const safeMonth = (v) => (/^\d{4}-\d{2}$/.test(v || '') ? v : currentMonth())

/** Downloads a GET endpoint (under the API base) as a file; name from Content-Disposition when exposed. */
export const downloadFile = async (getDownload, url, fallback) => {
  const res = await getDownload(url)
  const cd = res.headers?.['content-disposition'] || ''
  const m = /filename="?([^";]+)"?/i.exec(cd)
  const name = m ? m[1] : fallback
  const href = window.URL.createObjectURL(res.data)
  const a = document.createElement('a')
  a.href = href
  a.download = name
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => window.URL.revokeObjectURL(href), 1000)
}
